import React from 'react';
import { Flex, Button, Typography, Dropdown } from 'antd';
import { useNinjaTable } from 'components/tables/NinjaTable/useNinjaTable';
import Icon from '@mdi/react';
import { mdiChevronDown } from '@mdi/js';
import ConfirmModal from 'components/Dialogs/ConfirmModal';
import Confirmation from 'components/Dialogs/Confirmation';
import UrlHelper from 'common/utils/url-helper';

const ExportButton = () => {
  const { onExport } = useNinjaTable();

  const handleStatus = () => {
    ConfirmModal({
      title: (
        <p className='!font-normal'>
          You can export up to 1,000 rows at a time. If you need to export more, please{' '}
          <a href={UrlHelper.home('/contact-us')} target='_blank' rel='noopener noreferrer'>
            contact our support team
          </a>{' '}
          for assistance.
        </p>
      ),
      iconType: 'warning',
      okText: 'Export',
      cancelText: 'Cancel',
      onOk: () => onExport('all'),
    });
  };

  const items = [
    {
      key: 'current',
      label: (
        <span className='text-sm' size='small' type='text' onClick={() => onExport('current')}>
          Export current page
        </span>
      ),
    },
    {
      key: 'all',
      label: (
        <span className='text-sm ' size='small' type='text' onClick={handleStatus}>
          Export all data
        </span>
      ),
    },
  ];

  return (
    <div className='w-52'>
      <Flex
        align='center'
        justify='space-between'
        gap='small'
        className='bg-background-light p-2 rounded-md'
      >
        <Flex gap='small' align='center'>
          <img src='/icons/export/excell.svg' className='w-6 h-6' />
          <Typography className='text-sm'>Excel</Typography>
        </Flex>
        <Dropdown size='small' menu={{ items }}>
          <Button iconPosition='end' icon={<Icon path={mdiChevronDown} />}>
            Export
          </Button>
        </Dropdown>
      </Flex>
    </div>
  );
};

export default ExportButton;
